import React from 'react'
import { Link } from 'react-router-dom'

function LearnMore({ link, className, tooltip }) {
    return (
        <Link className={className} to={link}><i className='fa fa-plus text-info hover-rotate' data-bs-toggle="tooltip" title={tooltip}></i></Link>
    )
}

export default LearnMore